// toggleSubscribeAndUnlockModal.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { SUBSCRIPTION_PAYMENT_GATEWAY } from '../RemoteConfigKeys.js';

import toggleModal from '../action/toggleModal.js';
import fetchStoredPaymentMethods from '../action/fetchStoredPaymentMethods.js';
import cancelShopping from '../action/cancelShopping.js';

import getListData from '../selector/getListData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { PaymentMethodUsage, ProductType } from '../resource/shopConstants.js';

export const MODAL_ID = 'SubscribeAndUnlockModal';

/**
 * Toggle subscribe and unlock modal
 * @kind action
 * @param {string} {userId} - user id.
 * @param {string} {messageId} - message id.
 * @param {string} {shopId} - shop id.
 * @param {string} {currency} - default subscription checkout currency.
 * @param {boolean} {isOpen = false} - is open modal.
 * @return {Promise} Action promise.
 */
const toggleSubscribeAndUnlockModal =
  ({ userId, messageId, shopId, currency, isOpen = false } = {}) =>
  async (dispatch, getState) => {
    if (isOpen) {
      dispatch(
        toggleModal({
          modalId: MODAL_ID,
          payload: {
            userId,
            messageId,
          },
          isOpen,
        })
      );
      const subscriptionProductIds =
        getListData(
          getState(),
          ['shop', shopId, currency, ProductType.SUBSCRIPTIONS, userId],
          'itemIds'
        ) || [];
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['shop'],
          data: {
            usingShopId: shopId,
            [shopId]: {
              subscribeUserId: userId,
            },
          },
        },
      });
      if (
        subscriptionProductIds.length &&
        'DIAMONDS' !== currency.toUpperCase()
      ) {
        await dispatch(
          fetchStoredPaymentMethods({
            usage: PaymentMethodUsage.SUBSCRIPTION,
            currency,
          })
        );
        const defaultPaymentSourceJointId = getMeData(
          getState(),
          'subscriptionPaymentMethods'
        )[0]?.jointId;
        return dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            data: {
              selectPaymentSourceJointId:
                defaultPaymentSourceJointId ||
                // TODO: use getPaymentSourceJointId
                `card-prime:card:${getRemoteConfigData(
                  getState(),
                  SUBSCRIPTION_PAYMENT_GATEWAY
                )}`,
            },
            selectPath: ['shop', shopId],
          },
        });
      }
      return dispatch({ type: '' });
    }
    dispatch(cancelShopping({ shopId }));
    return dispatch(
      toggleModal({
        modalId: MODAL_ID,
        isOpen,
      })
    );
  };

export default toggleSubscribeAndUnlockModal;
